import TabPage from "./../factories/tab-page";
import TabController from "./../factories/tab-controller";
import BaseViewModelModule from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
class TicketStatus extends BaseViewModelModule {
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    Status = ko.observable();
    TicketStatusTicketCategoryTab: TabPage;
    TabController: TabController;
    InitUrl() {
        return "TicketStatus/Init";
    }
    CompleteCheck() {
        if (this.Status != null) {
            return true;
        }
        return false;
    }
    init() {
        return super.init().then(() => {
            return super.InitTabController().then(() => {
                this.TicketStatusTicketCategoryTab = new TabPage();
                this.TicketStatusTicketCategoryTab.IsClosable(false);
                this.TicketStatusTicketCategoryTab.Url("TicketStatusTicketTypeCategoryTab");
                this.TabController.AddTab(this.TicketStatusTicketCategoryTab);
            });
        });
    }
}
export default TicketStatus;